// Unit price of a cart line. Draft order custom covers carry their price in
// `__basePrice` (the Shopify variant is a placeholder); every other line,
// including Cart Transform custom covers, uses the price Shopify calculated.
const getLineUnitPrice = (item) => {
    const basePrice = item?.node?.attributes?.find((attr) => attr.key === "__basePrice")?.value;
    if (basePrice) return +basePrice;

    return +(item?.node?.cost?.amountPerQuantity?.amount ?? item?.node?.merchandise?.price?.amount ?? 0);
};

export default getLineUnitPrice;
